import * as all from './index'
import {defineDynamicImport} from "../dynamicImport/defineDynamicImport";

const MyopMessages = {
    ...all
}

defineDynamicImport('MyopMessages', MyopMessages);
